const RolesAccess = {
  DIREKTUR: 'Direktur',
  SUPER_ADMIN: 'SuperAdmin',
  KAB_SUBDIT_REGISTRASI: 'KabSubdit Registrasi',
  KAB_SUBDIT_REKOMENDASI: 'KabSubdit Rekomendasi',
  PIC_REGISTRASI: 'PIC Registrasi',
  PIC_REKOMENDASI: 'PIC Rekomendasi',
  PIC_NOTIFIKASI: 'PIC Notifikasi',
  PIC_PELAPORAN: 'PIC Pelaporan',
  PIC_CMS: 'PIC CMS',
  PENGELOLA: 'Pengelola',
  PIC_KONSULTASI: 'PIC Konsultasi',
  PIC_USER: 'PIC User',
  KOORDINATOR: 'Koordinator',
};

export default RolesAccess;
